/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import * as userService from '../services/userService'
import * as affiliateService from '../services/affiliateService'
import DepositModel from '../components/sub_components/user/depositeModel'
import CreditRef from './sub_components/user/creditRef'
import WithdrawModel from '../components/sub_components/user/withdrawModel'
import CreditModel from '../components/sub_components/user/creditModel'
import DebitModel from '../components/sub_components/user/debitModel'
import PasswordModel from '../components/sub_components/user/passwordModel'
import StatusModel from '../components/sub_components/user/statusModel'
import LockModel from '../components/sub_components/user/lockModel'
import RGDepositModel from '../components/sub_components/user/rgDepositModel'
import RGWithdrawModel from './sub_components/user/rgWithdrawModel'
import SettlementModel from '../components/sub_components/user/settlementModel'
import UserEventExposure from '../components/sub_components/user/userEventExposure'
import * as apiUserService from '../services/apiUserService'
import Currency from './sub_components/currency'
import { CSVLink } from 'react-csv';
import printJS from 'print-js'
import Autocomplete from 'react-autocomplete';
import { BASE_IMAGE_PATH, BASE_IMAGE_PATH_NEW } from '../configs/api';
import { showChangePasswordBtn, showCasinoControlLink, showClubGames } from '../configs/casinoShowList';
import * as _ from 'lodash'
import * as userUtil from '../util/user.util';
import ClientParentSharingModel from './sub_components/user/clientParentSharingModel';
import { OPERATOR_ID } from '../configs/const';
import AffiliateRequestTr from './affiliateRequestTr';
import moment from 'moment';
import UpdateAffiliateModel from './sub_components/user/updateAffiliateModel';
import ResetPasswordAffiliateModel from './sub_components/user/resetPasswordAffiliateModel';
let userListInterval
let linkClickTimeout
let printClickTimeout
class AffiliateApprovedList extends Component {
   csvLink = React.createRef();
   constructor(props) {
      super(props);
      this.state = {
         uid: "",
         passcode: "",
         user_id: "",
         user_list: [],
         user_list_search: [],
         rg_user_list: {},
         pageLimit: 100,
         pageActive: 1,
         openPopup: "",
         selectedUser: "",
         currUserData: {},
         action: "",
         emptyClientList: false,
         shortFild: "username",
         shortType: "asc",
         searchText: "",
         showData: false,
         userDownlineList: [],
         userDownlineData: {},
         rgUserDownlineData: {},
         downline_user_id: "",
         select_downline_user_id: "",
         pdf_json: [],
         csv_json: [],
         isOfficeChannel: false,
         isOperator: false,
         allData: false,
         isOnlyClients: false,
         showClientParentSharing: false,
         selectedClientParentSharingUsr: "",
         affiliateList: [],
         selectedUser:null,
         showUpdateModel:false,
         showResetPasswordModel:false,
      };
   }
   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value })
   }
   componentDidMount() {
      this.getAffiliateApprovedLst();
   }

   getAffiliateApprovedLst() {
      const self = this;
      const { match: { params } } = this.props;
      let tokenData = localStorage.getItem('tokenData');
      if (!!tokenData) {
         tokenData = JSON.parse(tokenData);
         let body = {
            "parentId": !!params && !!params.usernm ? params.usernm : tokenData.sub
         }
         affiliateService.getAffiliateApprovedList(body["parentId"]).then(async (result) => {
            if (!!result) {
               if (!!result.isSuccess) {
                  self.setState({ affiliateList: result.data, showData: true });
               } else {
                  self.props.notify(result.exception.message, "error")
               }
            }
         })
      }
   }
   async componentDidMountTask() {
      const { match: { params } } = this.props;
      let tokenData = localStorage.getItem("tokenData")
      tokenData = JSON.parse(tokenData)
      let currUserData = localStorage.getItem("userAccData")
      currUserData = JSON.parse(currUserData)
      this.setState({ currUserData: currUserData, isOfficeChannel: (currUserData.username === 'office' || currUserData.parents.includes('office')), isOperator: currUserData.username === 'operator' })
      if (params.user_id) {
         let user_list = await userService.getUsersById(params.user_id)
         user_list = user_list.items
         Array.prototype.forEach.call(user_list, (user, i) => {
            if (user.role === "Client") {
               let avail = user.availableBalance
               avail = avail + user.upLineBalance + user.exposure
               user_list[i].availableBalance = avail
            }
         })

         let rg_users = {};
         // if(rg_user_list.length > 0){
         //    for (let rg_usr of rg_user_list) {
         //       rg_users[rg_usr.username] = rg_usr;
         //    }
         // }

         if (user_list.length > 0) {
            this.setState({ user_id: params.user_id, user_list: user_list, user_list_search: user_list, rg_user_list: rg_users, emptyClientList: false, showData: true }, () => {
               this.shortUser(this.state.shortFild, this.state.shortType)
            })
         } else {
            this.setState({ user_id: params.user_id, user_list: user_list, user_list_search: user_list, rg_user_list: rg_users, emptyClientList: true, showData: true }, () => {
               this.shortUser(this.state.shortFild, this.state.shortType)
            })
         }
      }
      else {
         let user_list = await userService.getUsersVsOnlyClient(this.state.isOnlyClients)
         user_list = user_list.items
         Array.prototype.forEach.call(user_list, (user, i) => {
            if (user.role === "Client") {
               let avail = user.availableBalance
               avail = avail + user.upLineBalance + user.exposure
               user_list[i].availableBalance = avail
            }
         })

         let rg_users = {};
         // if(rg_user_list.length > 0){
         //    for (let rg_usr of rg_user_list) {
         //       rg_users[rg_usr.username] = rg_usr;
         //    }
         // }

         if (user_list.length > 0) {
            this.setState({ user_list: user_list, user_list_search: user_list, rg_user_list: rg_users, emptyClientList: false, showData: true }, () => {
               this.shortUser(this.state.shortFild, this.state.shortType)
            })
         } else {
            this.setState({ user_list: user_list, user_list_search: user_list, rg_user_list: rg_users, emptyClientList: true, showData: true }, () => {
               this.shortUser(this.state.shortFild, this.state.shortType)
            })
         }
      }
      let self = this
      userListInterval = setInterval(async function userListGet() {
         clearInterval(userListInterval)
         if (params.user_id) {
            let user_list = await userService.getUsersById(params.user_id)
            user_list = user_list.items
            Array.prototype.forEach.call(user_list, (user, i) => {
               if (user.role === "Client") {
                  let avail = user.availableBalance
                  avail = avail + user.upLineBalance + user.exposure
                  user_list[i].availableBalance = avail
               }
            })

            let rg_users = {};
            // if(rg_user_list.length > 0){
            //    for (let rg_usr of rg_user_list) {
            //       rg_users[rg_usr.username] = rg_usr;
            //    }
            // }

            self.setState({ user_id: "", user_list: [] }, () => {
               if (user_list.length > 0) {
                  self.setState({ user_id: params.user_id, user_list: user_list, user_list_search: user_list, rg_user_list: rg_users, emptyClientList: false, showData: true }, () => {
                     self.shortUser(self.state.shortFild, self.state.shortType)
                  })
               } else {
                  self.setState({ user_id: params.user_id, user_list: user_list, user_list_search: user_list, rg_user_list: rg_users, emptyClientList: true, showData: true }, () => {
                     self.shortUser(self.state.shortFild, self.state.shortType)
                  })
               }
               userListInterval = setInterval(userListGet, 10000)
            })
         }
         else {
            let user_list = await userService.getUsersVsOnlyClient(self.state.isOnlyClients)
            user_list = user_list.items
            !!user_list && Array.prototype.forEach.call(user_list, (user, i) => {
               if (user.role === "Client") {
                  let avail = user.availableBalance
                  avail = avail + user.upLineBalance + user.exposure
                  user_list[i].availableBalance = avail
               }
            })

            let rg_users = {};
            // if(rg_user_list.length > 0){
            //    for (let rg_usr of rg_user_list) {
            //       rg_users[rg_usr.username] = rg_usr;
            //    }
            // }

            self.setState({ user_list: [] }, () => {
               if (user_list.length > 0) {
                  self.setState({ user_list: user_list, user_list_search: user_list, rg_user_list: rg_users, emptyClientList: false, showData: true }, () => {
                     self.shortUser(self.state.shortFild, self.state.shortType)
                  })
               } else {
                  self.setState({ user_list: user_list, user_list_search: user_list, rg_user_list: rg_users, emptyClientList: true, showData: true }, () => {
                     self.shortUser(self.state.shortFild, self.state.shortType)
                  })
               }
               userListInterval = setInterval(userListGet, 10000)
            })
         }
      }, 10000)
   }
   componentWillUnmount() {
      // clearInterval(userListInterval)
      // clearTimeout(linkClickTimeout)
      // clearTimeout(printClickTimeout)
   }
   shortUser(fild, shortType, pageChange) {
      let userList = this.state.user_list
      if (!!userList) {
         userList.sort((a, b) => (a["username"] > b["username"]) ? 1 : ((b["username"] > a["username"]) ? -1 : 0))
         if (fild !== "pendingBalance") {
            userList.sort((a, b) => (a[fild] > b[fild]) ? 1 : ((b[fild] > a[fild]) ? -1 : 0))
         } else {
            userList.sort((a, b) => (((!!a.creditRef ? a.creditRef : 0) - (!!a.balance ? a.balance : 0)) > ((!!b.creditRef ? b.creditRef : 0) - (!!b.balance ? b.balance : 0))) ? 1 : ((((!!b.creditRef ? b.creditRef : 0) - (!!b.balance ? b.balance : 0)) > ((!!a.creditRef ? a.creditRef : 0) - (!!a.balance ? a.balance : 0))) ? -1 : 0))
         }
         if (shortType === "dasc") {
            userList = userList.reverse()
         }
         userList.sort(function (a, b) { return b.isActive - a.isActive });
      }
      this.setState({ user_list: [] }, () => {
         this.setState({ pageActive: !!pageChange ? 1 : this.state.pageActive, user_list: userList, shortFild: fild, shortType: shortType })
      })
   }
   async closeAndUpdate() {
      let tokenData = localStorage.getItem("tokenData")
      tokenData = JSON.parse(tokenData)
      if (!!this.state.downline_user_id) {
         this.setState({ openPopup: '' }, () => {
            this.onSelectedUser(this.state.downline_user_id);
         });
      } else {
         let users = await userService.getUsersVsOnlyClient(this.state.isOnlyClients)
         users = users.items
         // let rg_user_list = []
         // if(!!tokenData && !!tokenData.sub){
         //    rg_user_list = await userService.getRealGamesChildUsers(tokenData.sub)
         // }

         let rg_users = {};
         // if(rg_user_list.length > 0){
         //    for (let rg_usr of rg_user_list) {
         //       rg_users[rg_usr.username] = rg_usr;
         //    }
         // }

         this.setState({ user_list: [], rg_user_list: {} }, () => {
            this.setState({ user_list: users, rg_user_list: rg_users, openPopup: "" }, () => {
               this.shortUser(this.state.shortFild, this.state.shortType)
            })
         })
      }
   }
   clean(obj) {
      for (var propName in obj) {
         if (obj[propName] === undefined) {
            delete obj[propName];
         }
      }
      return obj
   }

   async onPDFDownload(user_list_data, allData = false) {
      let pdf_json = []
      if (Object.keys(this.state.userDownlineData).length > 0) {
         pdf_json.push(this.state.userDownlineData)
      } else {
         pdf_json = user_list_data
      }
      this.setState({ pdf_json: [] }, () => {
         this.setState({ pdf_json: pdf_json, allData: allData }, () => {
            printClickTimeout = setTimeout(function () {
               printJS({
                  printable: 'printJS-div',
                  type: 'html',
                  style: '@page { size: Letter landscape;}',
                  targetStyles: ['*']
               })
            }, 500)
         })
      })
   }


   async onDownload(user_list_data, alldata = false) {
      const self = this;
      
      this.setState({ csv_json: [] }, () => {
         let items = []
         
            let i = 0

            for (let x of user_list_data) {
               if (alldata ? true : (i < (this.state.pageLimit * this.state.pageActive) && (i + 1) > (this.state.pageLimit * (this.state.pageActive - 1)))) {
                  let dictinory = {}
                  dictinory["User Name"] = x["username"]
                  dictinory["Name"] = x["name"]
                  dictinory["Mobile"] = x["mobile"]
                  dictinory["Parent Id"] = !!x["parentId"] ? x["parentId"] : ''
                  dictinory["Website"] = !!x["website"] ? x["website"] : ''
                  dictinory["Created Date"] = !!x["createdDate"] ? moment(x["createdDate"]).format('DD/MM/YYYY HH:mm:ss') : ''
                  dictinory["Sharing"] = x["sharing"]
                  dictinory["Affiliate Code"] = x["affiliateCode"]
                  dictinory["is Active"] = !x["isActive"] ? "Yes" : "No"
                  items.push(dictinory)
               }
               i += 1
            }

         this.setState({ csv_json: items }, () => {
            linkClickTimeout = setTimeout(function () {
               self.csvLink.current.link.click();
            }, 500)
         })
      })
   }

   onSearch(e) {
      let userList = this.state.user_list
      this.setState({ searchText: e.target.value, user_list: [], pageActive: 1 }, () => {
         this.setState({ user_list: userList })
      })
   }

   async onUserSearch(e, name, value) {
      if (value.length > 1) {
         this.setState({ [name]: value })
         let res = await userService.getUserSearch(this.state.currUserData.username, value)
         let lst = []
         for (let x of res.usersList) {
            lst.push({ label: x, value: x, title: x, name: x })
         }
         lst.sort(function (a, b) {
            if (a.value.toLowerCase() < b.value.toLowerCase()) return -1;
            if (a.value.toLowerCase() > b.value.toLowerCase()) return 1;
            return 0;
         });
         this.setState({ userDownlineList: lst })
      }
      else if (value === "") {
         this.setState({ [name]: value, userDownlineList: [], select_downline_user_id: "", userDownlineData: {}, rgUserDownlineData: {} })
      }
      else {
         this.setState({ [name]: value, userDownlineList: [] })
      }
   }

   async onSelectedUser(user_id) {
      let userDetail = await apiUserService.getDashboard(user_id)
      // let rg_userDetail = await userService.getRealGamesUsersByUserName(user_id)

      this.setState({ userDownlineData: {}, rgUserDownlineData: {}, user_id: "" },
         () => {
            this.setState({ userDownlineData: userDetail, rgUserDownlineData: {}, select_downline_user_id: user_id, downline_user_id: user_id })
         }
      )
   }

   async changeActivation(user, isActive) {
      this.setState({ openPopup: "l", action: isActive ? "userUnlock" : "userLock", selectedUser: user })
   }
   async changeBlocking(user, isBlock) {
      this.setState({ openPopup: "l", action: isBlock ? "betLock" : "betUnlock", selectedUser: user })
   }
   onClientDownLine(usr) {
      localStorage.setItem(usr.username, JSON.stringify(usr))
      window.open("/affiliateList/" + usr.username, "_blank")
   }
   sum(array, key) {
      return array.reduce((a, b) => a + (b[key] || 0), 0);
   }
   filterUserData() {
      let userList = this.state.user_list
      const self = this
      if (this.state.searchText !== "" || this.state.searchText !== null || this.state.searchText !== undefined) {
         userList = _.filter(userList, function (obj) {
            return (self.state.isOnlyClients ? (obj['username'].toLowerCase().indexOf(self.state.searchText.toLowerCase()) !== -1 || (userUtil.getAppropriateParent(obj.parents, self.state.currUserData.username)).toLowerCase().indexOf(self.state.searchText.toLowerCase()) !== -1) : (obj.username.toLowerCase().indexOf(self.state.searchText.toLowerCase()) !== -1));
         });
      }
      return Object.assign([], userList)
   }

   onOnlyClientButtonClick() {
      clearInterval(userListInterval);
      this.setState({ isOnlyClients: !this.state.isOnlyClients, searchText: '', downline_user_id: '', select_downline_user_id: "", userDownlineData: {}, user_list: [], user_list_search: [], showData: false, pageActive: 1 }, () => {
         clearInterval(userListInterval);
         this.componentDidMountTask();
      });
   }

   onAction(e) {
      const name = e.target.name;
      if (name === "first") {
         this.setState({ pageActive: 1 })
      } else if (name === "prev") {
         this.setState({ action: name }, this.setState({ pageActive: (this.state.pageActive - 1) }))
      } else if (name === "next") {
         this.setState({ action: name }, this.setState({ pageActive: (this.state.pageActive + 1) }))
      } else if (name === "last") {
         this.setState({ action: name }, this.setState({ pageActive: Math.ceil(this.state.user_list.length / this.state.pageLimit) }))
      }
   }


   showClientParentSharing(usr) {
      this.setState({ selectedClientParentSharingUsr: usr.username, showClientParentSharing: true });
   }

   hideClientParentSharing() {
      this.setState({ selectedClientParentSharingUsr: "", showClientParentSharing: false });
   }

   removeAffiliateRequestRow(itm){
      let affRequestLst = this.state.affiliateList;
      affRequestLst.splice(affRequestLst.indexOf(itm),1);
      this.setState({affiliateList : affRequestLst});
   }

   // onClientDownLine(usr) {
   //    localStorage.setItem(usr.username, JSON.stringify(usr))
   //    window.open("/clients/" + usr.username, "_blank")
   // }

   onActivateDeactivateClick(item){
      const self = this;
      let param = {
         "username": item.username,
         "isActive": !item.isActive
      }
      affiliateService.updateAffiliateUserStatusApi(param).then((res) => {
         if (res.isSuccess) {
            self.props.notify(`${param.isActive? 'Activated': 'Deactivated'} successfully!`, "success");
            let lst = self.state.affiliateList;
            let index = -1
            for(let i=0; i< lst.length;i++){
               if(lst[i].username === param.username){
                  index = i;
                  break;
               }
            }
            if(index>-1){
               lst[index].isActive = param.isActive;
               self.setState({affiliateList: lst});
            }

         } else {
            self.props.notify(res?.exception?.message, "error")
         }
      })
   }

   openUpdateModel(item){
      this.setState({
         selectedUser: item,
         showUpdateModel: true,
      })
   }

   closeUpdateModel(itm){
      let affiliateLstt = this.state.affiliateList;
      if(!!itm){
         for(let item of affiliateLstt){
            if(item.username === itm.username){
               item.name = itm['name'];
               item.mobile = itm['mobile'];
               break;
            }
         }
      }

      this.setState({
         selectedUser: null,
         showUpdateModel: false,
         affiliateList: affiliateLstt
      })
   }

   

   openResetPasswordModel(item){
      this.setState({
         selectedUser: item,
         showResetPasswordModel: true,
      })
   }

   closeResetPasswordModel(){
      this.setState({
         selectedUser: null,
         showResetPasswordModel: false
      })
   }
   

   getFilteredData(){
      let rtnvl = [...this.state.affiliateList];
      if(!!this.state.searchText){
         rtnvl = rtnvl.filter((itm)=> itm.username.includes(this.state.searchText) || itm.name.toLowerCase().includes(this.state.searchText.toLowerCase()) || itm.mobile.includes(this.state.searchText) || (!!itm.affiliateCode ? itm.affiliateCode.includes(this.state.searchText) : false ))
      }
      return rtnvl;
   }
   render() {
      let affiliateLst = this.getFilteredData()
      let lst = []
      let total_page = Math.ceil(affiliateLst.length / this.state.pageLimit)
      for (let x = 1; x <= total_page; x++) {
         if (this.state.pageActive === x || Math.abs(x - this.state.pageActive) <= 2 || (this.state.pageActive < 3 && x < 6) || (total_page - this.state.pageActive < 3 && total_page - x < 5)) {
            let htm = <button className={this.state.pageActive === x ? "btn btn-blue active pagewidth" : "btn btn-blue pagewidth"} key={"unsettle_btn_" + (x)} name="page_no" value={x} onClick={(e) => { { this.onAction(e) } this.setState({ pageActive: x }) }}>{x} </button>
            lst.push(htm)
         }
      }
      return (
         <div className="bethubs">
            <Header history={this.props.history} />
            <div className="wrapper">
               <div className="container-fluid container-padding-0">
                  <div className="row">
                     <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="main-box">
                           <div>
                              <h5 className="text-blue  mb-2">
                                 <span>Affiliate List</span>
                                 <div className="row user-header">
                                    <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8">
                                       <div className="d-flex float-left">
                                          <div className="form-group mb-0 d-inline">
                                             <input className="form-control  d-inline-block" onChange={(e) => { this.onSearch(e) }} type="text" placeholder="Search" aria-label="Search" value={this.state.searchText} />
                                          </div>
                                          <CSVLink
                                             data={this.state.csv_json}
                                             filename={"Affiliate List.csv"}
                                             asyncOnClick={true}
                                             className="d-none"
                                             ref={this.csvLink}>
                                          </CSVLink>
                                          <button className="btn btn-sm d-inline csv-icon p-0 pl-1" title="Export Data" onClick={(e) => this.onDownload(this.state.affiliateList, true)} disabled={this.state.affiliateList.length > 0 ? false : true}><img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/csv-icon.svg`}></img></button>
                                          <div style={{ display: "none" }}>
                                             <div id="printJS-div">

                                                <table id="exportall" className="table font-12 table-bordered table-sm w-100" style={{ border: "1px solid #000", color: "#212529", fontSize: '12px', width: '100%' }} >
                                                   <thead>
                                                      <tr>
                                                         <th>User Name</th>
                                                         <th>Name</th>
                                                         <th>Mobile</th>
                                                         <th>Referrer</th>
                                                         <th>Website</th>
                                                         <th>Date</th>
                                                         <th>Sharing</th>
                                                         <th>Affiliate Code</th>
                                                         <th>Active</th>
                                                      </tr>
                                                   </thead>
                                                   <tbody>
                                                      {this.state.pdf_json.length > 1 && this.state.pdf_json.map((usr, i) => {
                                                         return (<>
                                                            {(this.state.allData ? true : i < (this.state.pageLimit * this.state.pageActive) && (i + 1) > (this.state.pageLimit * (this.state.pageActive - 1))) && 
                                                               <tr>
                                                               <td><span><a className="hand" target='_blank' onClick={() => this.onClientDownLine(usr)} name={usr.username} value={usr.username}>{usr.username}</a></span></td>
                                                               <td><span>{usr.name}</span></td>
                                                               <td><span>{usr.mobile}</span></td>
                                                               <td><span>{!!usr.parentId ? usr.parentId : ''}</span></td>
                                                               <td><span>{!!usr.website ? usr.website : ''}</span></td>
                                                               <td><span>{!!usr.createdDate ? moment(usr.createdDate).format('DD/MM/YYYY HH:mm:ss') : ''}</span></td>
                                                               <td><span>{usr.sharing}</span></td>
                                                               <td><span>{usr.affiliateCode}</span></td>
                                                               <td><span>{usr.isActive ? 'Yes' : 'No'}</span></td>
                                                            </tr>
                                                      }
                                                         </>
                                                         )
                                                      })
                                                      }
                                                   </tbody>
                                                </table>
                                             </div>
                                          </div>
                                          <button className="btn btn-sm pdf-icon d-inline p-0" title="Export Data" onClick={(e) => this.onPDFDownload(this.state.affiliateList, true)} disabled={this.state.affiliateList.length > 0 ? false : true}>
                                             <img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/pdf-icon.svg`}></img>
                                          </button>
                                          {/* <button className="btn btn-sm d-inline csv-icon-all p-0 mx-2" title="Export All Data" onClick={(e) => this.onDownload(userList, true)} disabled={this.state.user_list.length > 0 ? false : true}>
                                             <img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/csv-icon-all.svg`}></img>
                                          </button>
                                          <button className="btn btn-sm pdf-icon-all d-inline p-0" title="Export All Data" onClick={(e) => this.onPDFDownload(userList, true)} disabled={this.state.user_list.length > 0 ? false : true}>
                                             <img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/pdf-icon-all.svg`}></img>
                                          </button> */}
                                       </div>

                                    </div>
                                    <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">

                                    </div>
                                 </div>
                              </h5>
                           </div>

                           <div className="row mt-1">
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12 table-responsive">
                                 {!!this.state.showData ?
                                    (!!affiliateLst && affiliateLst.length > 0 ?
                                       <table id="example" className="table table-striped table-bordered table-sm addpadding nowrap" style={{ width: "100%" }}>
                                          <thead>
                                          <tr>
                                                <th>
                                                   <span>User Name</span>
                                                   <span className="d-contant" style={{ float: "right" }}>
                                                      <span onClick={() => { this.shortUser("username", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                      <span onClick={() => { this.shortUser("username", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                   </span>
                                                </th>
                                                <th>Name
                                                   <span className="d-contant" style={{ float: "right" }}>
                                                      <span onClick={() => { this.shortUser("name", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                      <span onClick={() => { this.shortUser("name", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                   </span>
                                                </th>
                                                <th>Mobile
                                                   <span className="d-contant" style={{ float: "right" }}>
                                                      <span onClick={() => { this.shortUser("mobile", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                      <span onClick={() => { this.shortUser("mobile", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                   </span>
                                                </th>
                                                <th>Referrer</th>
                                                <th>Website</th>
                                                <th>Date
                                                   <span className="d-contant" style={{ float: "right" }}>
                                                      <span onClick={() => { this.shortUser("createdDate", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                      <span onClick={() => { this.shortUser("createdDate", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                   </span>
                                                </th>
                                                <th>Sharing
                                                   <span className="d-contant" style={{ float: "right" }}>
                                                      <span onClick={() => { this.shortUser("sharing", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                      <span onClick={() => { this.shortUser("sharing", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                   </span></th>
                                                <th>Affiliate Code</th>
                                                <th>Application No.</th>
                                                <th>Active
                                                   <span className="d-contant" style={{ float: "right" }}>
                                                      <span onClick={() => { this.shortUser("isActive", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                      <span onClick={() => { this.shortUser("isActive", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                   </span></th>
                                                <th>Action</th>
                                             </tr>
                                          </thead>
                                          <tbody>
                                             {affiliateLst.map((usr, i) => {
                                                if (this.state.allData ? "" : i >= (this.state.pageLimit * this.state.pageActive) || (i + 1) <= (this.state.pageLimit * (this.state.pageActive - 1))) {
                                                      return false
                                                   }
                                                return (
                                                   <>
                                                      {/* {i < (this.state.pageLimit * this.state.pageActive) && (i + 1) > (this.state.pageLimit * (this.state.pageActive - 1)) && */}
                                                      <tr>
                                                         <td><span><a className="hand" target='_blank' onClick={() => this.onClientDownLine(usr)} name={usr.username} value={usr.username}>{usr.username}</a></span></td>
                                                         <td><span>{usr.name}</span></td>
                                                         <td><span>{usr.mobile}</span></td>
                                                         <td><span>{!!usr.parentId ? usr.parentId : ''}</span></td>
                                                         <td><span>{!!usr.website ? usr.website : ''}</span></td>
                                                         <td><span>{!!usr.createdDate ? moment(usr.createdDate).format('DD/MM/YYYY HH:mm:ss') : ''}</span></td>
                                                         <td><span>{usr.sharing}</span></td>
                                                         <td><span>{usr.affiliateCode}</span></td>
                                                         <td><span>{!!usr.applicationNumber ? usr.applicationNumber : ''}</span></td>
                                                         <td><span>{usr.isActive ? 'Yes' : 'No'}</span></td>
                                                         <td>
                                                            <span>
                                                               <button className={`btn btn-sm ${usr.isActive ? 'btn-danger' : 'btn-blue'} `} onClick={()=>this.onActivateDeactivateClick(usr)}>{usr.isActive ? 'Deactivate' : 'Activate'}</button>
                                                               <button className={`btn btn-sm btn-dark ml-2`} onClick={()=>this.openUpdateModel(usr)}>Edit</button>
                                                               <button className={`btn btn-sm btn-dark ml-2`} onClick={()=>this.openResetPasswordModel(usr)}>Reset Password</button>
                                                            </span>
                                                         </td>
                                                      </tr>
                                                      {/* } */}
                                                   </>
                                                )
                                             })}
                                          </tbody>
                                       </table> :
                                       <span> No Record Found.</span>
                                    )
                                    :
                                    <span>Loading...</span>
                                 }
                              </div>
                           </div>

                           {
                              affiliateLst.length > 0 &&
                              <>
                                 <div className="row">
                                    <div className="col-12 col-sm-12 col-md-6"><span className="frleft">Showing {(this.state.pageLimit * (this.state.pageActive - 1)) + 1} to {(this.state.pageLimit * this.state.pageActive) < affiliateLst.length ? (this.state.pageLimit * this.state.pageActive) : affiliateLst.length} of {affiliateLst.length} entries</span></div>
                                    <div className="col-12 col-sm-12 col-md-6">
                                       <div className="btn-group float-right" role="group" aria-label="Basic example" id="pagination-btn">
                                          <button type="button" className="btn btn-blue" id="PrevPage" name="first" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === 1 ? true : false}>First</button>
                                          <button type="button" className="btn btn-blue" id="PrevPage" name="prev" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === 1 ? true : false}>Prev</button>
                                          {lst}
                                          <button type="button" className="btn btn-blue" id="NextPage" name="next" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === Math.ceil(affiliateLst.length / this.state.pageLimit) ? true : false}>Next</button>
                                          <button type="button" className="btn btn-blue" id="NextPage" name="last" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === Math.ceil(affiliateLst.length / this.state.pageLimit) ? true : false}>Last</button>
                                       </div>
                                    </div>
                                 </div>
                              </>
                           }
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <Footer />
            {this.state.showUpdateModel && <UpdateAffiliateModel selectedUser={this.state.selectedUser} closePopup={(itm)=>this.closeUpdateModel(itm)} notify={this.props.notify}/>}
            {this.state.showResetPasswordModel && <ResetPasswordAffiliateModel selectedUser={this.state.selectedUser} closePopup={()=>this.closeResetPasswordModel()} notify={this.props.notify}/>}
         </div>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(AffiliateApprovedList);